const configApp = {
  academyDomain: 'https://academia.vidroop.com',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.vidroop.com',
  apiVersion: 'v1',
  appDomain: 'https://academia.vidroop.com',
  authCallbackUrl: 'https://academia.vidroop.com/login',
  authClientId: '7N6X8qg65ZI2JGHhnlcF0d1n4xI17Nii',
  authDomain: 'vidroop.eu.auth0.com',
  classroomDomain: 'https://aula.vidroop.com/login',
  marketPlaceDomain: 'https://tienda.vidroop.com/academia',
  pdfGeneratorDomain: 'https://pdfgenerator.vidroop.com/v1/invoice',
  portalDomain: 'https://portal.test.vidroop.com',
  stripePublicKey: 'pk_live_Qwsbmkvxlg25iLrzNW9qM4vi',
  universityDomain: 'https://tienda.vidroop.com/academia/vidroop',
  vidroopAcademyId: 'aaae93fb-3b33-417b-89d1-302f54fcff2b',
  zendeskKey: '21304bac-9691-425d-ac5d-4cef3352f6b4',
  droopEvaluacionHabilitado: true,    // sin esto NO se puede armar el producto con Evaluaciones
	droopInteligenciaArtificialHabilitado: false
}

export default configApp
